var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 22,
    fill: "#EEF1FD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6501 30.91C17.6201 30.91 17.5801 30.93 17.5501 30.93C15.6101 29.97 14.0301 28.38 13.0601 26.44C13.0601 26.41 13.0801 26.37 13.0801 26.34C14.3001 26.7 15.5601 26.97 16.8101 27.18C17.0301 28.44 17.2901 29.69 17.6501 30.91Z",
    fill: "#405EDC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.94 26.45C29.95 28.44 28.3 30.05 26.29 31.02C26.67 29.75 26.99 28.47 27.2 27.18C28.46 26.97 29.7 26.7 30.92 26.34C30.91 26.38 30.94 26.42 30.94 26.45Z",
    fill: "#405EDC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.02 17.71C29.76 17.33 28.49 17.02 27.2 16.8C26.99 15.51 26.68 14.23 26.29 12.98C28.36 13.97 30.03 15.64 31.02 17.71Z",
    fill: "#405EDC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.65 13.0901C17.29 14.3101 17.03 15.5501 16.82 16.8101C15.53 17.0101 14.25 17.3301 12.98 17.7101C13.95 15.7001 15.56 14.0501 17.55 13.0601C17.58 13.0601 17.62 13.0901 17.65 13.0901Z",
    fill: "#405EDC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.49 16.59C23.17 16.33 20.83 16.33 18.51 16.59C18.76 15.22 19.08 13.85 19.53 12.53C19.55 12.45 19.54 12.39 19.55 12.31C20.34 12.12 21.15 12 22 12C22.84 12 23.66 12.12 24.44 12.31C24.45 12.39 24.45 12.45 24.47 12.53C24.92 13.86 25.24 15.22 25.49 16.59Z",
    fill: "#405EDC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.59 25.49C15.21 25.24 13.85 24.92 12.53 24.47C12.45 24.45 12.39 24.46 12.31 24.45C12.12 23.66 12 22.85 12 22C12 21.16 12.12 20.34 12.31 19.56C12.39 19.55 12.45 19.55 12.53 19.53C13.86 19.09 15.21 18.76 16.59 18.51C16.34 20.83 16.34 23.17 16.59 25.49Z",
    fill: "#405EDC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9999 22C31.9999 22.85 31.8799 23.66 31.6899 24.45C31.6099 24.46 31.5499 24.45 31.4699 24.47C30.1399 24.91 28.7799 25.24 27.4099 25.49C27.6699 23.17 27.6699 20.83 27.4099 18.51C28.7799 18.76 30.1499 19.08 31.4699 19.53C31.5499 19.55 31.6099 19.56 31.6899 19.56C31.8799 20.35 31.9999 21.16 31.9999 22Z",
    fill: "#405EDC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M25.49 27.41C25.24 28.79 24.92 30.15 24.47 31.47C24.45 31.55 24.45 31.61 24.44 31.69C23.66 31.88 22.84 32 22 32C21.15 32 20.34 31.88 19.55 31.69C19.54 31.61 19.55 31.55 19.53 31.47C19.09 30.14 18.76 28.79 18.51 27.41C19.67 27.54 20.83 27.63 22 27.63C23.17 27.63 24.34 27.54 25.49 27.41Z",
    fill: "#405EDC"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7633 25.7633C23.2622 26.0789 20.7378 26.0789 18.2367 25.7633C17.9211 23.2622 17.9211 20.7378 18.2367 18.2367C20.7378 17.9211 23.2622 17.9211 25.7633 18.2367C26.0789 20.7378 26.0789 23.2622 25.7633 25.7633Z",
    fill: "#405EDC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons3);
export default __webpack_public_path__ + "static/media/icons3.6e74199f91596af362aed5a8c6127709.svg";
export { ForwardRef as ReactComponent };